module.exports = __webpack_public_path__ + "img/icon-instagram.e3673644913b021c2301efd6bc5eaa03.svg";